import axios from 'axios';
import React, { useEffect, useState } from 'react';
import ReactApexChart from 'react-apexcharts';
import "./Review.css"

const Review = () => {
    const [state, setState] = useState({
        series: [
            {
                data: [],
            },
        ],
        options: {
            chart: {
                type: 'bar',
                height: 350,

            },
            plotOptions: {
                bar: {
                    borderRadius: 4,
                    borderRadiusApplication: 'end',
                    horizontal: true,
                    style: {

                    }
                },
            },
            dataLabels: {
                enabled: false,
            },
            xaxis: {
                categories: [],
            },
        },
    });

    const [review, setReview] = useState([]);
    const [recomondations, setRecomondations] = useState([]);
    const API_BASE_URL = process.env.REACT_APP_API_KEY;

    const storedData = JSON.parse(localStorage.getItem("outletdataLocal")) || {};

    let outletId, outletlogo;
    
    // Check if storedData is an array or an object
    if (Array.isArray(storedData) && storedData.length > 0) {
        outletId = storedData[0].outletId;
        //outletlogo = storedData[0].outletlogo;
    } else if (storedData && typeof storedData === "object") {
        outletId = storedData.outletId;
        //outletlogo = storedData.outletlogo;
    }    

    const apiReviews = async () => {
        try {
            const response = await axios.get(
                `${API_BASE_URL}FeedBackRating/GetOutletReviews?outletId=${outletId}`
            );
            const reviews = response.data;

            // Process the API response to update the chart data
            const categories = reviews.map((review) => review.feedBackName);
            const data = reviews.map((review) =>
                review.marksCount > 0 ? (review.totalMarks / review.marksCount).toFixed(2) : 0
            );

            // Update the chart state
            setState((prevState) => ({
                ...prevState,
                series: [{ data }],
                options: {
                    ...prevState.options,
                    xaxis: {
                        ...prevState.options.xaxis,
                        categories,
                    },
                },
            }));

            setReview(reviews);
        } catch (error) {
            console.error('Reviews not found.', error);
        }
    };
    const apiRecomodations = async () => {
        try {
            const response = await axios.get(
                `${API_BASE_URL}FeedBackRating/GetRatingsByOutletId?OutletId=${outletId}`
            );
            setRecomondations(response.data)
        } catch (error) {
            console.log("Recomondations not found", error);
        }
    }

    useEffect(() => {
        apiReviews();
        apiRecomodations();
    }, []);

    return (
        <div className="container-fluid">
            <div className="col-md-12">
                <div className="row">
                    <div className='mt-3 mb-1 text-center'>
                        <h6> Customer Reviews </h6>
                        <div className='border-top border-dark'></div>
                    </div>
                    <div id="chart">
                        <ReactApexChart
                            options={state.options}
                            series={state.series}
                            type="bar"
                            height={350}

                        />
                        <div className='border-top border-dark'></div>

                    </div>
                    <div className="m-2">
  <div style={{ height: "350px", overflowY: "auto", padding: "8px", border: "2px solid #ddd" }}>
    {recomondations.map((rcmnd) =>
      rcmnd.recommantion ? (
        <React.Fragment key={rcmnd.guestName}>
          <span>{rcmnd.guestName || "Visitor"}</span> <br />
          <b>{rcmnd.recommantion}</b> <br /><br />
        </React.Fragment>
      ) : null
    )}
  </div>


                        

                    </div>

                </div>
            </div>
        </div>
    );
};

export default Review;
